<!-- eslint-disable vue/no-v-html -->
<template>
  <section>
    <p v-if="formConfig.third_party_email_collection_disclaimer" class="caption">
      <input id="email-consent" type="checkbox" :value="has3pEmailConsent" @change="on3pChange" />
      <label for="email-consent" v-html="formConfig.third_party_email_collection_disclaimer" />
    </p>
  </section>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'Section3pEmailConsent',
  computed: {
    ...mapState('actionForm', ['formConfig', 'has3pEmailConsent'])
  },
  methods: {
    on3pChange(evt) {
      this.$store.commit('actionForm/SET_HAS_3P_EMAIL_CONSENT', evt.target.checked)
    }
  }
}
</script>
